import React, { useCallback, useEffect } from "react";
import { Card, Row, Col, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setFilters } from "../DirectExpenseBalanceSlice";
import SearchListAutoComplete from "../../../components/SearchListAutoComplete";
import { SearchOutlined } from "@ant-design/icons";
import RecordDateFilter from "../../../components/filters/RecordDateFilter";
import {
  fetchDirectExpenseBalance,
  fetchDirectExpenseAccountsBySearch,
} from "../DirectExpenseBalanceThunk";
import { useLocation, useSearchParams } from "react-router-dom";
import { useDefaultDateRange } from "../../../hooks/useDefaultDateRange";
import CommonDateRangeFilter from "../../../components/common/filters/CommonDateRangeFilter";

const DirectExpenseBalanceFilters = ({ messageApi }) => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.directExpenseBalance);
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const dateFrom = searchParams.get("dateFrom");
    const dateTo = searchParams.get("dateTo");

    if (dateFrom && dateTo) {
      const dateFilters = {
        filterType: "All Expense Account",
        accId: null,
        fromDate: dateFrom,
        toDate: dateTo,
      };
      dispatch(setFilters(dateFilters));
      dispatch(fetchDirectExpenseBalance({ filters: { ...filters, ...dateFilters } }));
      return;
    }

    const path = pathname.split("/")[3];
    if (path) {
      handleFilterChange("filterType", "Date Wise");
      handleFilterChange("toDate", path);
      handleSubmit();
    }
  }, []);

  useDefaultDateRange(setFilters, filters, "today");

  const handleFilterChange = (field, value) => {
    dispatch(setFilters({ [field]: value }));
  };
  const searchAccount = useCallback(
    (text) => dispatch(fetchDirectExpenseAccountsBySearch(text)),
    [dispatch]
  );

  const handleSubmit = () => {
    if (!filters.filterType) {
      messageApi.warning("Select Filter Type");
      return;
    }
    dispatch(fetchDirectExpenseBalance({ filters })).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        messageApi.success("Report loaded ✅");
      } else {
        messageApi.error("Failed to fetch report ❌");
      }
    });
  };

  return (
    <Card className="mb-4 shadow-md rounded-xl">
      <Row gutter={16} style={{ alignItems: "center" }}>
        {/* Filter Type */}
        <Col xs={24} sm={12} md={8} lg={6} xl={4}>
          <label>Filter Type</label>
          <SearchListAutoComplete
            optionsList={[
              {
                sale_id: "All Expense Account",
                display_text: "All Expense Account",
              },
              {
                sale_id: "Expense Account Wise",
                display_text: "Expense Account Wise",
              },
            ]}
            value={{
              value: filters.filterType,
              label:
                filters.filterType === "Expense Account Wise"
                  ? "Expense Account Wise"
                  : "All Expense Account",
            }}
            onSelect={(obj) => handleFilterChange("filterType", obj?.sale_id)}
            placeholder="Filter Type"
            showAddNew={false}
          />
        </Col>

        {/* Account dropdown only when Wise */}
        {filters.filterType === "Expense Account Wise" && (
          <Col xs={24} sm={12} md={8} lg={6} xl={4}>
            <label>Search Account</label>
            <SearchListAutoComplete
              entityType="account"
              searchThunk={searchAccount}
              resultSelector={(state) =>
                state.directExpenseBalance.directAccounts
              }
              onSelect={(obj) => handleFilterChange("accId", obj?.sale_id)}
              placeholder="Account"
              showAddNew={false}
            />
          </Col>
        )}

        {/* Date filter */}
        <CommonDateRangeFilter
          filters={filters}
          onChange={(fromDate, toDate) => {
          handleFilterChange("fromDate", fromDate);
          handleFilterChange("toDate", toDate);
          }}
        />

        <Col
          xs={24}
          sm={12}
          md={8}
          lg={6}
          xl={4}
          style={{ display: "flex", alignItems: "flex-end", height: 58 }}
        >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleSubmit}
            block
            data-testid="report-btn"
          >
            Report
          </Button>
        </Col>
      </Row>
    </Card>
  );
};

export default DirectExpenseBalanceFilters;
